import { FC } from "react";
import {
  Container,
  Loader,
  LoaderFrom,
  ProgressBar,
  ProgressPrev,
} from "./StepFromProgress.styled";
import { useTranslation } from "../../../hooks/useTranslation";

type Props = {
  count: number;
  value: number;
};

export const StepFromProgress: FC<Props> = ({ count, value }) => {
  const { t } = useTranslation();

  return (
    <Container>
      <Loader>{t("stepProgress")}</Loader>
      <ProgressBar>{value + 1}</ProgressBar>
      <LoaderFrom>{t("fromProgress")}</LoaderFrom>
      <ProgressPrev>{count}</ProgressPrev>
    </Container>
  );
};
